import {svgIconWrapper} from '../svg-icon-wrapper';

import RevenueCloudFXRegular from './revenue-cloud-fx-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <RevenueCloudFXRegular {...props} />;
}

SvgComponent.iconName = 'revenueCloudFXRegular';

export const RevenueCloudFXRegularIcon = svgIconWrapper(SvgComponent);
